/* GENERAL FUNCTIONS */
jQuery(document).ready(function(){
  jQuery.getJSON('/products/prescription-cost.js', function(product) {
    jQuery('#pres_cost').val(JSON.stringify(product.variants));
  } );
});
function addToCartWithPrescriptionValidation(){
	var returnAdd = true;
  	jQuery('#addto_error1').hide();
  	jQuery('#addto_error2').hide();
  	jQuery('.addto_error3').hide();
	var array_json = jQuery('#chosen_pres').val();
	var arrayj = JSON.parse(array_json);
  	var pres_type = arrayj.pres_type;
    var file=document.getElementById('prescriptionFileUpload').value;
    if(!jQuery(".pres_option.providepres.active").length && pres_type != "reading"){ // if any of them is selected
    	jQuery('#addto_error1').show();
  		jQuery('#addto_error2').hide();
  		jQuery('.addto_error3').hide();
  		returnAdd = false;
    }
  	else{
  		if (jQuery(".pres_option.providepres.active.upload").length && pres_type != "reading") { // if upload is selected
  			if(file=="" || jQuery('#upload_error').css('display')!="none"){ // if file is uploaded
  				jQuery('#addto_error1').hide();
  				jQuery('#addto_error2').show();
  				jQuery('.addto_error3').hide();
  				returnAdd = false;
  			}
  		}
  		else if (jQuery('.pres_option.providepres.active[value="doctor"]').length && pres_type != "reading") { // if doctor is selected
          console.log("tuka doaga");
  			if( (arrayj.patient_name == undefined || arrayj.patient_name == "") || (arrayj.patent_dob == undefined || arrayj.patent_dob == "") || (arrayj.dr_name == undefined || arrayj.dr_name == "") || (arrayj.dr_phone == undefined || arrayj.dr_phone == "") || (arrayj.dr_state == undefined || arrayj.dr_state == "")){
				jQuery('#addto_error1').hide();
  				jQuery('#addto_error2').hide();
  				jQuery('.addto_error3').show();
  				returnAdd = false;
			}
  		}
  	}
	return returnAdd;
}
function addToCartWithPrescription(){
if(addToCartWithPrescriptionValidation()){
  jQuery('body').addClass('loading');
  calculatePrice();
  setTimeout(function(){ 
    saveIntoItem();
  }, 500);
  //add prescription cost products in cart
  var variants_data = JSON.parse(jQuery('#pres_cost').val());
  var chosen_pres = JSON.parse(jQuery('#chosen_pres').val());
  var pres_type_sku = "";
  var lens_type_sku = "";
  var lens_mat_sku = "";
  var pres_type = chosen_pres.pres_type;
  var lens_type = chosen_pres.lens_type;
  var lens_material = chosen_pres.lens_material;
  if(pres_type == "single_vision"){
    pres_type_sku = "prescription-type-single-vision";
  }else if(pres_type == "progressive"){
    pres_type_sku = "prescription-type-progressive";
  }
  if(lens_type == "clear"){
    lens_type_sku = "lens-type-clear";
  }else if(lens_type == "sunglasses"){
    lens_type_sku = "lens-type-sunglasses";
  }else if(lens_type == "light_responsive"){
    lens_type_sku = "lens-type-light-responsive";
  }
  
  if(lens_type == "sunglasses"){
    if(lens_material == "polycarbonate"){
    	lens_mat_sku = "lens-material-polycarbonate-for-sunglasses";
    }else if(lens_material == "plastic"){
    	lens_mat_sku = "lens-material-plastic-for-sunglasses";
    }else if(lens_material == "1.67"){
    	lens_mat_sku = "lens-material-1-67-high-index-for-sunglasses";
    }
  }
  else{
  	if(lens_material == "polycarbonate"){
    	lens_mat_sku = "lens-material-polycarbonate";
    }else if(lens_material == "1.67"){
    	lens_mat_sku = "lens-material-1-67-high-index";
    }
  }
  var ids = [];
  jQuery.each( variants_data, function( key, value ) {
    if(pres_type_sku == value.sku || lens_type_sku == value.sku || lens_mat_sku == value.sku){
      if(value.price > 0){
        	ids.push(value.id);
    
      }
    }
  });
  setTimeout(function(){ 
    if(ids[0]){
	    jQuery.post('/cart/add.js', {quantity: 1,id: ids[0]});
    }
  }, 1000);
  setTimeout(function(){ 
    //jQuery.post('/cart/add.js', {quantity: 1,id: ids[1]});
    if(ids[1]){
	    jQuery.post('/cart/add.js', {quantity: 1,id: ids[1]});
    }
  }, 1500);
  setTimeout(function(){ 
    //jQuery.post('/cart/add.js', {quantity: 1,id: ids[2]});
    if(ids[2]){
	    jQuery.post('/cart/add.js', {quantity: 1,id: ids[2]});
    }
  }, 2000);
  setTimeout(function(){ 
    jQuery('#AddToCart-product-template').click();
  }, 2500);
  


/* UPLOAD LINK */
    setTimeout(function(){ 
       var uploaded_files = jQuery('#uploaded_files').val();
         if(uploaded_files != ""){
           	jQuery.post('/cart/update.js', {note: uploaded_files});
           }
  		}, 3000);
/* UPLOAD LINK */


}
}
function saveOption(opt,val){
	var array_json = document.getElementById('chosen_pres').value;
	var array = JSON.parse(array_json);
	array[opt] = val;
	document.getElementById('chosen_pres').value = JSON.stringify(array);
}
function saveIntoItem(){
  
  var array_json = jQuery('#chosen_pres').val();
  var arrayj = JSON.parse(array_json);
  var pres_text = "";
  var pres_vars = {"upload_filename":"Uploaded File","price":"Price","pres_type":"Prescription Type","single_vision":"Single Vision","progressive":"Progressive","reading":"Reading","lens_type":"Lens Type","clear":"Clear","sunglasses":"Sunglasses","light_responsive":"Light Responsive","lens_tint":"Lens Tint","True Grey":"True Grey","G15 Grey/Green":"G15 Grey/Green","Brown":"Brown","lens_material":"Lens Material","plastic":"Plastic","polycarbonate":"Polycarbonate","1.67":"1.67 High Index","upload":"Upload a photo of it","email":"Send it later","doctor":"Call a doctor","patient_name":"Patient's Name","patient_dob":"Patient's Date of Birth","dr_name":"Doctor's Name","dr_phone":"Doctor's Phone","dr_state":"Doctor's State","strength":"Magnification Strength","provide_pres":"Provide Prescription"};
  $.each(arrayj, function(idx, obj) {
    if(idx == "price"){
      pres_text += pres_vars[idx] + ": $" + returnPrice() + "\n";
    }else if(idx == "upload_filename"){
      pres_text += pres_vars[idx] + ": " + obj + "\n";
    }else{
      pres_text += pres_vars[idx] + ": " + pres_vars[obj] + "\n";
    }
  });
  jQuery('#product_prescription_field').val(pres_text);
}
function updateTotals(){
	var lens_price = returnPrice();
  	var total_price = returnPrice() + 95;
  	jQuery('.total_pres_price').html("$" + lens_price);
  	jQuery('.total_cart_price').html("$" + total_price);
}
function returnPrice(){
	var pres_json = jQuery('#chosen_pres').val();
	var pressj = JSON.parse(pres_json);
	var prices_json = jQuery('#pres_prices').val();
	var pricesj = JSON.parse(prices_json);
	var pres_type = pressj.pres_type;
	var lens_type = pressj.lens_type;
	var lens_material_type = "other";
	var lens_material = pressj.lens_material;
	if(lens_type == "sunglasses"){
		lens_material_type = "sunglasses";
	}
  if(lens_material == "1.67"){
  	lens_material = "high";
  }
	var prestype_price = pricesj["pres_type"][pres_type];
	var lenstype_price = pricesj["lens_type"][lens_type];
	var lensmat_price = pricesj["lens_material"][lens_material_type][lens_material];
	var total = prestype_price + lenstype_price + lensmat_price;
  	return total;
}
function calculatePrice(){
	saveOption("price",returnPrice());
}
function PresRadio(th,a){
	jQuery('.presradio').removeClass('active');
	jQuery(th).addClass('active');
	if(a == 1){
		jQuery('#prescription_form').show();
		jQuery('#addtocart_form').hide();
	}else{
		jQuery('#addtocart_form').show();
		jQuery('#prescription_form').hide();
	}
}
function OpenPres(){
	jQuery('#mkmage_prescriptions').show();
  	jQuery('#mkmage_prescriptions').addClass('resize');
	var headerh = jQuery('.resize').height() + 0;
	jQuery('#MainContent').css('height',headerh + 'px');
	jQuery('#MainContent').css('overflow','hidden');
  	
}
function closePres(){
	jQuery('#mkmage_prescriptions').hide();
	jQuery('#MainContent').css('height','');
	jQuery('#MainContent').css('overflow','');
	jQuery('#product_prescription_field').val("");
}
/* GENERAL FUNCTIONS */

/* Prescription steps list */
function gotoStep1(){
	jQuery('#step_01').show();
	jQuery('#step_02').hide();
	jQuery('#step_03').hide();
  	jQuery('#step_04').hide();
	jQuery('#step_05').hide();
	jQuery('#step_06').hide();
	var headerh = jQuery('.resize').height() + 0;
	jQuery('#MainContent').css('height',headerh + 'px');
	jQuery('#MainContent').css('overflow','hidden');
}
function gotoStep2(){
	jQuery('#step_01').hide();
	jQuery('#step_02').show();
	jQuery('#step_03').hide();
	jQuery('#step_04').hide();
	jQuery('#step_05').hide();
	jQuery('#step_06').hide();
	var headerh = jQuery('.resize').height() + 0;
	jQuery('#MainContent').css('height',headerh + 'px');
	jQuery('#MainContent').css('overflow','hidden');
}
function gotoStep3(){
	jQuery('#step_01').hide();
	jQuery('#step_02').hide();
	jQuery('#step_03').show();
	jQuery('#step_04').hide();
  	jQuery('#step_05').hide();
	jQuery('#step_06').hide();
	var headerh = jQuery('.resize').height() + 0;
	jQuery('#MainContent').css('height',headerh + 'px');
	jQuery('#MainContent').css('overflow','hidden');
  	
  	
}
function gotoStep4(){
    var array_json = jQuery('#chosen_pres').val();
  	var arrayj = JSON.parse(array_json);
    if(arrayj.lens_material == undefined || arrayj.lens_material == 'undefined' || arrayj.lens_material == null || arrayj.lens_material == 'null'){
      jQuery('#material_error').show();
    }else{
      jQuery('#material_error').hide();
      jQuery('#step_01').hide();
	  jQuery('#step_02').hide();
	  jQuery('#step_03').hide();
	  jQuery('#step_04').show();
  	  jQuery('#step_05').hide();
	  jQuery('#step_06').hide();
	  var headerh = jQuery('.resize').height() + 0;
	  jQuery('#MainContent').css('height',headerh + 'px');
	  jQuery('#MainContent').css('overflow','hidden');
  	  updateTotals();
   }
}
function gotoStep6(){
	jQuery('#step_01').hide();
	jQuery('#step_02').hide();
	jQuery('#step_03').hide();
	jQuery('#step_04').hide();
  	jQuery('#step_05').hide();
	jQuery('#step_06').show();
	var headerh = jQuery('.resize').height() + 0;
	jQuery('#MainContent').css('height',headerh + 'px');
	jQuery('#MainContent').css('overflow','hidden');
}
/* Prescription steps list */



/* STEP 1 */
function ActivateThis01(){
	jQuery("#active01").addClass("active");
	jQuery("#active02").removeClass("active");
	jQuery("#active03").removeClass("active");
	jQuery("#hide_butt").show();
  	jQuery("#show_butt").hide();
}
function ActivateThis02(){
	jQuery("#active01").removeClass("active");
	jQuery("#active02").addClass("active");
	jQuery("#active03").removeClass("active");
  	jQuery("#hide_butt").show();
  	jQuery("#show_butt").hide();
}
function ActivateThis03(){
	jQuery("#active01").removeClass("active");
	jQuery("#active02").removeClass("active");
	jQuery("#active03").addClass("active");
  	jQuery("#hide_butt").hide();
  	jQuery("#show_butt").show();
}
function PopUpPrescription1(){
	jQuery('#myid').show();
}

function AddToCart(){
	jQuery('#AddToCart-product-template').click();
}
/* STEP 1 */


/* STEP 2 */
function ActivateThis1(){
	jQuery("#active1").addClass("active");
	jQuery("#active2").removeClass("active");
	jQuery("#active3").removeClass("active");
	jQuery("#tints_options").hide();
	jQuery("#active11").hide();
	jQuery("#step_030").removeClass("three_col");
  	jQuery('.other_price').show();
  	jQuery('.sunglass_price').hide();
}
function ActivateThis2(){
	jQuery("#active1").removeClass("active");
	jQuery("#active2").addClass("active");
	jQuery("#active3").removeClass("active");
  	jQuery("#tints_options").show();
  	jQuery("#active11").show();
  	jQuery("#step_030").addClass("three_col");
  	jQuery('.other_price').hide();
  	jQuery('.sunglass_price').show();
}
function ActivateThis3(){
	jQuery("#active1").removeClass("active");
	jQuery("#active2").removeClass("active");
	jQuery("#active3").addClass("active");
	jQuery("#tints_options").hide();
	jQuery("#active11").hide();
	jQuery("#step_030").removeClass("three_col");
  jQuery('.other_price').show();
  	jQuery('.sunglass_price').hide();
}

function showTintName1(){
	jQuery(".tint_title1").show();
}
function hideTintName1(){
	jQuery(".tint_title1").hide();
}
function showTintName2(){
	jQuery(".tint_title2").show();
}
function hideTintName2(){
	jQuery(".tint_title2").hide();
}
function showTintName3(){
	jQuery(".tint_title3").show();
}
function hideTintName3(){
	jQuery(".tint_title3").hide();
}
function ActivThis1(){
	jQuery("#activ1").addClass("active");
	jQuery("#activ2").removeClass("active");
	jQuery("#activ3").removeClass("active");

}
function ActivThis2(){
	jQuery("#activ1").removeClass("active");
	jQuery("#activ2").addClass("active");
	jQuery("#activ3").removeClass("active");

}
function ActivThis3(){
	jQuery("#activ1").removeClass("active");
	jQuery("#activ2").removeClass("active");
	jQuery("#activ3").addClass("active");
	
}
function PopUpPrescription2(){
	jQuery('#myid2').show();
  	
}
/* STEP 2 */


/* STEP 3 */

function ActivateThis11(){
	jQuery("#active11").addClass("active");
	jQuery("#active22").removeClass("active");
	jQuery("#active33").removeClass("active");
}
function ActivateThis22(){
	jQuery("#active11").removeClass("active");
	jQuery("#active22").addClass("active");
	jQuery("#active33").removeClass("active");
}
function ActivateThis33(){
	jQuery("#active11").removeClass("active");
	jQuery("#active22").removeClass("active");
	jQuery("#active33").addClass("active");
}
function PopUpPrescription3(){
	jQuery('#myid3').show();
}
/* STEP 3 */

/* STEP 4 */

function ActivateLast1(){
	jQuery("#active_l1").addClass("active");
	jQuery("#active_l2").removeClass("active");
	jQuery("#active_l3").removeClass("active");
  	jQuery('#prescriptionFileUpload').click();
  	
}
function ActivateLast2(){
	jQuery("#active_l1").removeClass("active");
	jQuery("#active_l2").addClass("active");
	jQuery("#active_l3").removeClass("active");
}
function ActivateLast3(){
	jQuery("#active_l1").removeClass("active");
	jQuery("#active_l2").removeClass("active");
	jQuery("#active_l3").addClass("active");
	jQuery('#step_05').show();
	jQuery('#step_04').hide();
  	updateTotals();
  	
}
function PopUpPrescription4(){
	jQuery('#myid4').show();
}
function submitUploadPrescription(){
	var error=false;
	var file=document.getElementById('prescriptionFileUpload').value;
  	console.log("Here Is");	
  	console.log(file);
	if(file!=""){
		var files=document.getElementById('prescriptionFileUpload').files;
		var re = /(?:\.([^.]+))?$/;
		var k=0;
		if(file==""){
		
			jQuery('#upload_error').html("Please select a file.");
			jQuery('#upload_error').show();
			error=true;
		}
		else{
			jQuery('#upload_error').html("")
			jQuery('#upload_error').hide();
			for(var i=0;i<files.length;i++){
				var ext = re.exec(files[i].name)[1];   
				if(ext!="pdf" && ext!="jpg" && ext!="png" && ext!="doc" && ext!="docx" && ext!="txt" && ext!="gif" && ext!="PDF" && ext!="JPG" && ext!="PNG" && ext!="DOC" && ext!="DOCX" && ext!="TXT" && ext!="GIF"){
					jQuery('#upload_error').html("Please upload a file with one of the allowed extensions:<br>pdf, jpg, png, doc, docx, txt, gif");
					jQuery('#upload_error').show();
					error=true;
				}else{
					jQuery('#upload_error').html("");
					jQuery('#upload_error').hide();
					if(files[i].size>5242880){
						jQuery('#upload_error').html("Please upload a file smaller than 5MB.");
						jQuery('#upload_error').show();
						error=true;
					}else{
						jQuery('#upload_error').html("")
						jQuery('#upload_error').hide();
						var formData = new FormData(jQuery('#upload_form')[0]);
                      	formData.append("user","mkmage");
                      	formData.append("pass","jonmul1212");
						var percent=0;
                      	jQuery('body').addClass('loader');
						jQuery.ajax({
							type:'POST',
							url: jQuery('#upload_form').attr('action'),
							data:formData,
							cache:false,
							contentType: false,
							processData: false,
                          	crossDomain: true,
                          	dataType: 'json',
							success:function(data){
								var messageJson = data;
								var filename = messageJson.filename;
                              	jQuery.getJSON('/cart.js',function(data){
                                  	var note = data.note;
                                  	if(note == null ){ note = ""; }
                                  	var uploaded_files = note + "http://mkmage.com/glass_and_lens/download_prescription/download.html?filename="+filename+"\n";
                                  jQuery('#uploaded_files').val(uploaded_files);
                                });
                              	saveOption('upload_filename',filename);//"http://mkmage.com/gaffos/download_prescription/download.html?filename="+filename);
								jQuery('#uploaded_file').html("File successfully uploaded.");// Click <a href='http://mkmage.com/gaffos/uploads/"+filename+"' download>here</a> to download");
								jQuery('#uploaded_file').show();
                              	jQuery('#addto_error2').hide();  
								jQuery('body').removeClass('loader');
                              	if(jQuery(window).width() <= 768 ) {
									jQuery("html, body").animate({ scrollTop: 700 }, "slow");
								}
							},
							error: function(data){
								jQuery('#upload_error').html("An error occurred, your file cannot be saved. Please try again.");
								jQuery('#upload_error').show();
								error=true;
                              	jQuery('body').removeClass('loader');
							}
							/*,xhr:function (){
								var jqXHR = null;
								if(window.ActiveXObject){
									jqXHR = new window.ActiveXObject( "Microsoft.XMLHTTP" );
								}
								else{
									jqXHR = new window.XMLHttpRequest();
								}
								jqXHR.upload.addEventListener( "progress", function ( evt ){
									if ( evt.lengthComputable ){
										var percentComplete = Math.round( (evt.loaded * 100) / evt.total );
										var bars=document.getElementById('progressBar');
										bars.style.width=percentComplete+"%";
									}
								}, false );		    
								return jqXHR;
							}*/
						});
					}
				}
			}
		}
	}
	else{
		jQuery('#upload_error').html = "An error occurred, please try again.";
		jQuery('#upload_error').show();
		error=true;
	}

	if(error==false){
		console.log("GO TO NEXT STEP");
	}
}


/* STEP 4 */


/* STEP 5 */
function PopUpPrescription5(){
	jQuery('#myid5').show();
}

/* STEP 5 */

/* STEP 6 */
function upperRP(){
	var field  = document.getElementById('reading_strength');
	var field_value = parseFloat(field.getAttribute('val'));
	var newval = field_value + 0.25;
	if(newval <= 3.50){
		field.setAttribute('val',newval);
		field.value = newval;
		saveOption('strength',newval);
	}
}
function lowerRP(){
	var field  = document.getElementById('reading_strength');
	var field_value = parseFloat(field.getAttribute('val'));
	var newval = field_value - 0.25;
	if(newval >= 0.75){
		field.setAttribute('val',newval);
		field.value = newval;
		saveOption('strength',newval);
	}
}
function saveReading(){
	var field  = document.getElementById('reading_strength');
	var field_value = parseFloat(field.getAttribute('val'));
	saveOption('strength',field_value);
}
/* STEP 6 */